(function () {


    function init() {
        try {
            // Get the search term from URL query parameter
            const searchTerm = window.feReusable.getQueryParam('text');

            // Check if search term contains "juniper" (case-insensitive)
            if (searchTerm && searchTerm.toLowerCase().includes('juniper')) {
                // Redirect to Juniper category page
                const redirectUrl = 'https://buy.hpe.com' + window['feHPEB2C'].baseUrl() + '/juniper/c/juniper';
                window.feHPEB2C.log('FE:4057 - Redirecting to Juniper category page:', redirectUrl);
                window.location.href = redirectUrl;
            }
        } catch (error) {
            window.feHPEB2C.log('Error in FE:4057 - Juniper search redirect:', error);
        }
    }

    window.feUtils.waitForConditions({
        conditions: ['body'],
        activity: feProjectId,
        callback: init,
    })

})();
